<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入名称"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="records"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="10"> </el-table-column>
      <el-table-column type="index" label="序号" min-width="10">
      </el-table-column>
      <el-table-column
        prop="userInfo"
        label="人员"
        min-width="10"
        show-overflow-tooltip
      >
        <template slot-scope="scope"
          >{{ scope.row.userInfo ? scope.row.userInfo.uLoginName : "" }}({{
            scope.row.userInfo ? scope.row.userInfo.uRealName : ""
          }})</template
        >
      </el-table-column>
      <el-table-column
        prop="product"
        label="兑换商品"
        min-width="20"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{ scope.row.product.name }}</template>
      </el-table-column>
      <el-table-column
        prop="integral"
        label="兑换积分"
        show-overflow-tooltip
        min-width="10"
      ></el-table-column>
      <el-table-column
        prop="description"
        label="描述"
        show-overflow-tooltip
        min-width="30"
      ></el-table-column>
      <el-table-column
        prop="state"
        label="状态"
        show-overflow-tooltip
        min-width="10"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 'Unapproved'" type="warning"
            >待审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Approved'" type="success"
            >已审核</el-tag
          >
          <el-tag v-if="scope.row.state == 'Rejected'" type="danger"
            >已驳回</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="时间"
        show-overflow-tooltip
        min-width="20"
      ></el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="积分兑换-编辑"
      v-if="currentUser"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="兑换商品" prop="productId">
              <ProductSelect
                v-model="editForm.product"
                style="width: 100%"
                :integral="currentUser.integral"
                @input="productSelected"
              ></ProductSelect>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="积分兑换-发起"
      v-if="currentUser"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户" prop="uLoginName">
              <el-input v-model="currentUser.uLoginName" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="当前积分" prop="integral">
              <el-input v-model="currentUser.integral" readonly></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="兑换商品" prop="productId">
              <ProductSelect
                v-model="addForm.product"
                style="width: 100%"
                :integral="currentUser.integral"
                @input="productSelected"
              ></ProductSelect>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {
  queryIntegralExchangeListPage,
  approveIntegralExchange,
  saveIntegralExchange,
  getUserByToken,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ProductSelect from "../../components/ProductSelect";
import { IntegralExchangeStateEnum } from "../../api/enum";

export default {
  components: { Toolbar, ProductSelect },
  data() {
    return {
      currentUser: null,
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      records: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false,
      editLoading: false,
      editFormRules: {
        productId: [
          { required: true, message: "请选择可兑换的商品", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: "",
        productId: "",
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        productId: [
          { required: true, message: "请选择可兑换的商品", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        product: {
          id: "",
        },
        productId: "",
      },
    };
  },
  methods: {
    productSelected(productId) {
      if (this.addFormVisible) {
        this.addForm.productId = productId;
      } else if (this.editFormVisible) {
        this.editForm.productId = productId;
      }
    },
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    handleQuery() {
      this.listLoading = true;
      //NProgress.start();
      queryIntegralExchangeListPage(this.filter).then((res) => {
        if(res.data.isSuccess){
          this.pageModel = res.data.response;
          this.records = res.data.response.data;
        }
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //审核
    handleApprove() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要审核的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.state != "Unapproved") {
        this.$message({
          message: "该数据已审核过！",
          type: "error",
        });
        return;
      }
      this.$prompt("备注", "审核", {
        confirmButtonText: "确定",
      })
        .then(({ value }) => {
          this.listLoading = true;
          //NProgress.start();
          let para = {
            state: IntegralExchangeStateEnum.Approved,
            id: row.id,
            remark: value,
          };
          approveIntegralExchange(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "审核成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch((action) => {});
    },
    //驳回
    handleReject() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要驳回的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.state != "Unapproved") {
        this.$message({
          message: "该数据已审核过！",
          type: "error",
        });
        return;
      }
      this.$prompt("备注", "驳回", {
        confirmButtonText: "驳回",
      })
        .then(({ value }) => {
          this.listLoading = true;
          //NProgress.start();
          let para = {
            state: IntegralExchangeStateEnum.Rejected,
            id: row.id,
            remark: value,
          };
          approveIntegralExchange(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "驳回成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch((action) => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.updateCurrentUserInfo();
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.product = { id: this.editForm.productId };
    },
    //显示新增界面
    handleAdd() {
      this.updateCurrentUserInfo();
      this.addFormVisible = true;
      this.addForm = {
        product: { id: "" },
        productId: "",
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let formData = new FormData();
            this.editForm.productId = this.editForm.product.id;
            this.editForm.integral = this.editForm.product.needIntegral;
            this.editForm.product = null;
            formData.append("model", JSON.stringify(this.editForm));
            saveIntegralExchange(formData).then((res) => {
              this.editLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            this.addForm.userId = this.currentUser.uID;
            this.addForm.productId = this.addForm.product.id;
            this.addForm.integral = this.addForm.product.needIntegral;
            this.addForm.product = null;
            formData.append("model", JSON.stringify(this.addForm));
            saveIntegralExchange(formData).then((res) => {
              this.addLoading = false;
              if (res.data.isSuccess) {
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    updateCurrentUserInfo() {
      getUserByToken({
          token: window.localStorage.Token
      }).then((res) => {
        if (res.isSuccess) {
          this.currentUser = res.response;
          window.localStorage.user = JSON.stringify(res.response);
        }
      });
    },
  },
  mounted() {
    this.currentUser = this.getCurrentUser();
    this.handleQuery();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
